import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type HeaderItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.BeheerHeader, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isInterneGebruiker &&
    (settings.heeftBeheerboxRechten || settings.heeftAdviseurbeheerRechten),
  create: (): HeaderItem => ({
    itemtype: 'header',
    menuItem: MenuItems.BeheerHeader,
    title: 'Beheer',
  }),
});
